function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { useEffect, useState } from 'react';

/**
 * A hook for easy handling of Autcomplete searches.
 * Automatically handles searches that can resolve to a URL by going to that URL.
 * For non immediate searches or immediate searches with no inherent URL, calls an optional `urlResolver`
 * function.  If that returns a URL, then the user is taken to it.  Otherwise flow passes through
 * to the optional `onSearch` callback.
 *
 * In order to work with an external RecentSearches list, `immediateTypes` should be passed.
 * Use the same value used with the Autocomplete - if using a preset there will be an `immediateTypes` static field.
 * eg. `ListingSearchAutocomplete.immediateTypes`
 *
 * The parameter listingType is used to set the listing category (BUY, RENT, etc.) for analytics events
 * that originate in this hook.
 *
 * sends event `autocomplete-search` with payload `type (immediate|manual)` and `items`
 *
 * If the search resolves to a URL, it also sets the `pending` status on the Autocomplete
 */
var useSearchHandlers = _ref => {
  var urlResolver = _ref.urlResolver,
    _ref$onSearch = _ref.onSearch,
    onSearchCallback = _ref$onSearch === void 0 ? () => {} : _ref$onSearch,
    _ref$onRedirect = _ref.onRedirect,
    onRedirect = _ref$onRedirect === void 0 ? () => {} : _ref$onRedirect,
    _ref$immediateTypes = _ref.immediateTypes,
    immediateTypes = _ref$immediateTypes === void 0 ? [] : _ref$immediateTypes,
    listingType = _ref.listingType;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    pending = _useState2[0],
    setPending = _useState2[1];
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var isImmediate = item => immediateTypes.includes(item === null || item === void 0 ? void 0 : item.type);
  useEffect(() => {
    // reset the pending state if the user hits "back"
    var resetPending = () => setPending(false);
    window.addEventListener('pageshow', resetPending);
    return () => window.removeEventListener('pageshow', resetPending);
  }, []);
  var goToUrl = destination => {
    new Promise(resolve => {
      resolve(onRedirect(destination));
    }).catch(() => {});
    window.location = destination;
  };
  var doSearchFallback = values => {
    try {
      onSearchCallback(values);
    } finally {
      setPending(false);
    }
  };
  var onSearch = values => {
    setPending(true);
    Promise.resolve(urlResolver === null || urlResolver === void 0 ? void 0 : urlResolver(values)).then(destination => {
      sendEvent('autocomplete-search', {
        type: 'manual',
        listingType,
        items: values
      });
      if (destination) {
        goToUrl(destination);
      } else {
        doSearchFallback(values);
      }
    });
  };
  var onImmediateSearch = value => {
    setPending(true);
    Promise.resolve(value.url || (urlResolver === null || urlResolver === void 0 ? void 0 : urlResolver([value]))).then(destination => {
      sendEvent('autocomplete-search', {
        type: 'immediate',
        listingType,
        items: [value]
      });
      if (destination) {
        goToUrl(destination);
      } else {
        doSearchFallback([value]);
      }
    });
  };

  // Directs recent search entries to the correct search type
  var onRecentSearch = value => {
    if (isImmediate(value[0])) {
      onImmediateSearch(value[0]);
    } else {
      onSearch(value);
    }
  };
  return {
    pending,
    onImmediateSearch,
    onRecentSearch,
    onSearch
  };
};
export default useSearchHandlers;